<template>

    <flickity ref="flickity" :options="flickityOptions" class="OOP-today__flickity" v-if="Object.keys(groupedMatches).length > 0">

        <div class="OOP-today__matches__row" v-for="rowMatches in groupedMatches">
            <score-card
                v-for     = "match in rowMatches"
                :match    = "match"
                v-if      = "showMatch(match)"
                :flagPath = "flag"
                :key      = "match.id"
                :detail   = "detail"
                :type     = "assoc"
                :mode     = "mode"
                :data-id  = "match.id">
            </score-card>
        </div>

    </flickity>

</template>

<script>
    import MatchCard from './MatchCard.vue'
    import Flickity from './Flickity';
    import 'select2/dist/js/select2.full.js'

    export default {
        props: [ 'assoc', 'flag', 'detail', 'matches', 'class_name', 'mode' ],
        components: {
            'score-card' : MatchCard,
            Flickity
        },
        data() {
            return {
                flickityOptions : {
                    cellSelector    : '.OOP-today__matches__row',
                    prevNextButtons : true,
                    pageDots        : true,
                }
            }
        },
        mounted() {

            let carousel = jQuery('.' + this.class_name + ' .OOP-today__flickity').flickity()

            carousel.flickity('destroy')

            let holder_height = jQuery('.' + this.class_name + ' .Match__head').outerHeight() + jQuery('.' + this.class_name + ' .Match__body').outerHeight();

            //height
            jQuery('.' + this.class_name + ' .OOP-today__flickity').css( { 'height' : holder_height + 16 } )
            jQuery('.' + this.class_name + ' .OOP-today__matches__row').css( { 'height' : holder_height + 16 } )

            jQuery('.' + this.class_name + ' .OOP-today__flickity').flickity( [ this.flickityOptions ] )

            if ( this.groupedMatchesWatch().length < 2 )
                jQuery( '.' + this.class_name + ' .flickity-page-dots' ).hide()
            else
                jQuery( '.' + this.class_name + ' .flickity-page-dots' ).show()
        },
        computed: {
            groupedMatches() {
                let grouped = [];
                let index = -1;

                for (let i = 0; i < this.matches.length; i++) {
                    if (i % 2 == 0) {
                        index++;
                        grouped[index] = [];
                    }
                    grouped[index].push(this.matches[i]);
                }

                return grouped;
            }
        },
        methods: {
            getMatchesByCourt(name) {
                let foundCourt = this.courts.filter(function (court) {
                    return court.name == name
                })

                return foundCourt[0].matches
            },
            showMatch(match) {
                if ( !match.detail )
                    return false

                if ( this.mode == 'live' )
                    return true

                if ( match.detail.state == 'F' )
                    return true
            },
            groupedMatchesWatch() {
                let grouped = [];
                let index = -1;

                for (let i = 0; i < this.matches.length; i++) {
                    if (i % 2 == 0) {
                        index++;
                        grouped[index] = [];
                    }
                    grouped[index].push(this.matches[i]);
                }

                return grouped;
            }
        }
    }
</script>
